import {
  useContext,
  createContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { io, Socket } from "socket.io-client";
import { useNavigationContext } from "./navigation-context";

type TCreditsResponse = {
  type: string;
  accountId: string;
  creditsAdded: string;
  newBalance: string;
};

interface ISocketContextProps {
  socket: Socket | null;
  sendMessage: (event: string, data: any) => void;
  creditsResponse: TCreditsResponse;
}

const SocketContext = createContext({} as ISocketContextProps);

export const SocketProvider = ({ children }: { children: ReactNode }) => {
  const { selectedAccountCombo } = useNavigationContext();
  const [socket, setSocket] = useState<Socket | null>(null);
  const [creditsResponse, setCreditsResponse] = useState<TCreditsResponse>({
    type: "",
    accountId: "",
    creditsAdded: "",
    newBalance: "",
  });

  useEffect(() => {
    if (!selectedAccountCombo) return;

    console.debug("Iniciou o socket");
    const socketInstance = io(import.meta.env.VITE_APP_URL_BASE);
    setSocket(socketInstance);

    socketInstance.on(`accounts/${selectedAccountCombo}`, (data) => {
      console.debug("Received data on account");
      setCreditsResponse(JSON.parse(data.message));
    });

    return () => {
      console.debug("Desconectando socket");
      socketInstance.disconnect();
    };
  }, [selectedAccountCombo]);

  const sendMessage = (event: string, data: any) => {
    if (socket) {
      socket.emit(event, data);
    }
  };

  return (
    <SocketContext.Provider value={{ socket, sendMessage, creditsResponse }}>
      {children}
    </SocketContext.Provider>
  );
};

// eslint-disable-next-line
export const useSocketContext = () => useContext(SocketContext);
